import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import classNames from 'classnames'
import { IncreaseLoanAmountBannerAccent } from '@/components/banners/IncreaseLoanAmountBannerAccent'
import { openModal } from '@/components/composed/Modal/actions'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { Button } from '@/components/ui'
import { getUserGtmInfo } from '@/logic/metrika/helpers'
import { pushGtmEventOnClickFinancingActionOffer } from '@/pages/AdvancePaymentOnFutureHarvest/gtm-helpers'
import type { RootState } from '@/redux/interfaces'
import { isNonNullable } from '@/typeguards/common'
import { formatLocalizedString } from '@/utils/formatUtils'
import LandingConsultingModal from '../../../../../../components/composed/modals/LandingConsultingModal'
import { messages } from './messages'
import type { TAdvancePaymentCalculatorResultProps } from './types'
import './styles.scss'

addModalToWellKnown({
  LandingConsultingModal,
})

const mapState = (state: RootState) => ({
  userGtmInfo: getUserGtmInfo()(state),
})

export const AdvancePaymentCalculatorResult: React.FC<TAdvancePaymentCalculatorResultProps> = ({
  deliveryVolume,
  isLoading,
  className,
  onClickSubmitApplication,
}) => {
  const dispatch = useDispatch()
  const { userGtmInfo } = useSelector(mapState)
  const { userRegion } = useUserRegion()

  const handleClickConsulting = () => {
    pushGtmEventOnClickFinancingActionOffer(userGtmInfo, userRegion.name, 'consult-calculator')
    dispatch(openModal({ options: { dialogId: 'LandingConsultingModal' }, contentOptions: { isShowUxFeedback: true } }))
  }

  return (
    <div className={classNames('advancePaymentCalculatorResult', className)}>
      <div className="advancePaymentCalculatorResult__card">
        {isLoading ? (
          <div className="advancePaymentCalculatorResult__loader h4">{messages.field.deliveryVolume.loading}</div>
        ) : (
          <>
            <div className="advancePaymentCalculatorResult__label">{messages.field.deliveryVolume.label}</div>
            <div className="advancePaymentCalculatorResult__value h2">{deliveryVolume ?? messages.field.deliveryVolume.unknownValue}</div>
            {isNonNullable(deliveryVolume) && (
              <div className="advancePaymentCalculatorResult__valueUnit h4">
                {formatLocalizedString(messages.field.deliveryVolume.valueUnit, {
                  value: deliveryVolume,
                })}
              </div>
            )}
          </>
        )}
        <Button
          className="advancePaymentCalculatorResult__submitApplication"
          modifiers={['green', 'full-width-always']}
          onClick={onClickSubmitApplication}
        >
          {messages.button.submitApplication}
        </Button>
        <Button
          className="advancePaymentCalculatorResult__requestConsultation"
          modifiers={['outline', 'full-width-always']}
          onClick={handleClickConsulting}
        >
          {messages.button.requestConsultation}
        </Button>
      </div>
      <IncreaseLoanAmountBannerAccent
        className="advancePaymentCalculatorResult__banner"
        comment={messages.increaseLoanAmountBanner.comment}
      />
    </div>
  )
}
